import axios from "axios";
import * as Constants from "./Constants";
import {toast} from "react-toastify";
import {jwtDecode} from "jwt-decode";
import {logoutFun} from "../component/HomeSideNavBar";

export function generateColors(numColors) {
  // Create an empty array to store the generated colors.
  const colors = [];

  // Generate a random number between 0 and 255 for each color channel (red, green, blue).
  for (let i = 0; i < numColors; i++) {
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);

    // Add the generated color to the colors array.
    colors.push(`rgb(${red}, ${green}, ${blue})`);
  }

  // Return the colors array.
  return colors;
}

export function parseJsonIfNotEmpty(input) {
  // Check if the trimmed input has a length greater than zero
  if (null != input) {
    const trimmedInput = input.trim();
    try {
      // Attempt to parse the trimmed input as JSON
      const parsedJson = JSON.parse(trimmedInput);
      return parsedJson;
    } catch (error) {
      // JSON parsing failed, handle the error if needed
      console.error("Error parsing JSON:", error);
      return null; // Return null or handle the error case accordingly
    }
  } else {
    // Return null for empty input
    return null;
  }
}

export function getCurrentTimeMillis() {
  return Date.now();
}

export async function getGeolocationFromLatLng(latitude, longitude) {
  try {
    let endpoint = Constants.GMAP_LOCATION_API_URL;

    if (
      latitude === undefined ||
      latitude === null ||
      latitude === "" ||
      longitude === undefined ||
      longitude === null ||
      longitude === ""
    ) {
      return "Invalid input";
    }

    const config = {
      transformRequest: [
        (data, headers) => {
          delete headers.Authorization;
          return data;
        },
      ],
    };

    endpoint =
      endpoint +
      "key=" +
      process.env.REACT_APP_GMAP_API_KEY +
      "&latlng=" +
      latitude +
      "," +
      longitude;

    return axios
      .get(endpoint, config)
      .then((response) => {
        // Handle the response.
        if (response.data.results.length > 0) {
          console.log(response.data.results[0].formatted_address);
          return response.data.results[0].formatted_address;
        } else {
          throw new Error(
            "Failed to fetch location details: " + response.data.status
          );
        }
      })
      .catch((error) => {
        // Handle the error.
        console.error(error);
        return null; // Return null if location details cannot be fetched
      });
  } catch (error) {
    console.error(error);
    return null; // Return null if location details cannot be fetched
  }
}

export function formatDateToDDMMYYYY(inputDate) {
  // Parse the input date in yyyy-mm-dd format
  const parsedDate = new Date(inputDate);

  // Check if the parsing was successful
  if (isNaN(parsedDate.getTime())) {
    throw new Error("Invalid date format");
  }

  // Extract day, month, and year components
  const day = String(parsedDate.getDate()).padStart(2, "0");
  const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = parsedDate.getFullYear();

  // Assemble the date in dd/mm/yyyy format
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
}

export function getClientIdOfUser() {
  const loggedInUser = JSON.parse(
    localStorage.getItem(Constants.LOGGED_IN_USER)
  );
  if (!loggedInUser || !loggedInUser.clientId) {
    logoutFun(); // Call the logout function if loggedInUser or clientId is null
  } else {
    return loggedInUser.clientId;
  }
}

export function getLoggedInUserId() {
  const loggedInUser = JSON.parse(
    localStorage.getItem(Constants.LOGGED_IN_USER)
  );
  if (!loggedInUser || !loggedInUser.userId) {
    logoutFun(); // Call the logout function if loggedInUser or userId is null
  } else {
    return loggedInUser.userId;
  }
}

export function getAuthToken() {
  try {
    const storedToken = localStorage.getItem(Constants.LOGGED_IN_USER);

    if (!storedToken) {
      return null; // Token not found
    }

    const decodedToken = jwtDecode(storedToken);

    if (!decodedToken || !decodedToken.exp) {
      // Remove expired token from storage
      localStorage.removeItem(Constants.LOGGED_IN_USER);
      return null; // Token invalid or missing expiration
    }

    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      // Remove expired token from storage
      localStorage.removeItem(Constants.LOGGED_IN_USER);
      return null; // Token expired
    }

    return JSON.parse(storedToken).jwtToken; // Token is valid
  } catch (error) {
    console.error("Error decoding token:", error);
    localStorage.removeItem(Constants.LOGGED_IN_USER);
    return null; // Handle potential token errors
  }
}

export async function getDataFromBackend(endPoint) {
  axios.defaults.headers.common["Authorization"] = `${
    Constants.BEARER
  } ${getAuthToken()}`;

  return await axios.get(`${Constants.BASE_URL}${endPoint}`);
}

export const showToast = (message, options = {}) => {
  toast(message, options);
};

/**
 * Compact display stamp ("24 May 2026, 13:29") in the viewer's locale.
 * Returns null for missing/invalid input so callers can fall back to "—".
 */
export const formatDateTime = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (isNaN(d.getTime())) return null;
  const date = d.toLocaleDateString(undefined, {day: "2-digit", month: "short", year: "numeric"});
  const time = d.toLocaleTimeString(undefined, {hour: "2-digit", minute: "2-digit", hour12: false});
  return `${date}, ${time}`;
};

/**
 * Hover text combining registration + last-edit stamps, e.g.
 * "Registered 24 May 2026, 13:29 · Updated 01 Jun 2026, 09:12".
 */
export const registeredUpdatedTitle = (registered, updated) => {
  const parts = [];
  const reg = formatDateTime(registered);
  const upd = formatDateTime(updated);
  if (reg) parts.push(`Registered ${reg}`);
  if (upd) parts.push(`Updated ${upd}`);
  return parts.join(" · ") || "No dates recorded";
};

export function generateRandomNumber() {
  // Generate a random number between 100000000000 and 999999999999
  return Math.floor(Math.random() * 900000000000) + 100000000000;
}

/**
 * Converts a Unix timestamp (in milliseconds) into a formatted date/time string (DD/MM/YYYY HH:MM:SS).
 * @param {number | Date} timestamp - The Unix timestamp in milliseconds or a Date object.
 * @returns {string} The formatted date string, or 'Invalid Date' if the input is bad.
 */
export const formatDateTo_DDMMYYYY_HHMMSS = (timestamp) => {
  // 1. Ensure we have a valid Date object
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // 2. Use helper to ensure 2 digits (e.g., '5' becomes '05')
  const pad = (num) => String(num).padStart(2, "0");

  // 3. Extract and format date parts
  const day = pad(date.getDate());
  const month = pad(date.getMonth() + 1); // getMonth() is 0-indexed
  const year = date.getFullYear();

  // 4. Extract and format time parts
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  // 5. Assemble the final string
  return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

// --- Alternative using Intl.DateTimeFormat (More robust but potentially slower) ---

/**
 * Converts a Unix timestamp (in milliseconds) into a formatted date/time string (DD/MM/YYYY HH:MM:SS)
 * using Intl.DateTimeFormat for locale-specific formatting.
 * This method is generally better for ensuring consistent zero-padding and time format.
 * @param {number | Date} timestamp - The Unix timestamp in milliseconds or a Date object.
 * @returns {string} The formatted date string, or 'Invalid Date' if the input is bad.
 */
export const formatDateIntl = (timestamp) => {
  const date = timestamp instanceof Date ? timestamp : new Date(timestamp);

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // Define formatting options to get the exact required format
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // Ensure 24-hour format
  };

  // Use 'en-GB' locale for guaranteed DD/MM/YYYY order.
  // The format will be "DD/MM/YYYY, HH:MM:SS" (note the comma and space).
  const formattedString = new Intl.DateTimeFormat("en-GB", options).format(
    date
  );

  // Remove the comma and extra space if present to strictly match "DD/MM/YYYY HH:MM:SS"
  return formattedString.replace(",", "");
};

export const getLoggedInUser = () => {
  try {
    const user = localStorage.getItem(Constants.LOGGED_IN_USER);
    return user ? JSON.parse(user) : null;
  } catch (e) {
    return null;
  }
};

// Example Usage (for testing purposes, remove or comment out in utilities.js)
/*
const sampleTimestamp = 1755361909000;
console.log('Using standard Date methods:', formatDateTo_DDMMYYYY_HHMMSS(sampleTimestamp));
console.log('Using Intl.DateTimeFormat:', formatDateIntl(sampleTimestamp)); 
*/
